<template>
  <!-- 骑行轨迹详情 -->
  <div class="map">
    <el-dialog
      :title="$t('menu.fenceTrajectory')"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="map-content">
        <MapRiding :locationList="locationList" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
        <el-button type="primary" @click="handleClose">{{
          $t("button.determine")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MapRiding from "./mapRiding.vue";
export default {
  data() {
    return {
      locationList: [],
    };
  },
  components: {
    MapRiding,
  },
  watch: {
    dialogVisible(newValue) {
      this.locationList = null;
      if (newValue) {
        this.openMap = true;
        this.locationList = this.trackData;
      }
    },
  },
  mounted() {
    this.locationList = null;
  },
  props: ["dialogVisible", "trackData"],
  methods: {
    handleClose() {
      this.$emit("dialogClose");
    },
  },
};
</script>

<style scoped>
.map-content {
  width: 100%;
  height: 500px;
}
</style>